// removed by extract-text-webpack-plugin
module.exports = {"background":"WaitingPopover_background--3xSkN","wrapper":"WaitingPopover_wrapper--30tx1","spinner":"WaitingPopover_spinner--tJ6wE","timer":"WaitingPopover_timer--3N1Y0","description":"WaitingPopover_description--2Yvn8","button":"WaitingPopover_button--2uoB2"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/WaitingPopover/WaitingPopover.scss
// module id = 475
// module chunks = 11 12